import delayRule from '@/models/delay/delay-rule'
import { IDelayState } from './interfaces/delay-state'

export default class DelayState implements IDelayState {
  public delayRules: delayRule[] = []
}
